<template>
  <v-container class="no-margins">
    <h1>{{ $t('application.message.title') }}</h1>

    <template v-if="isApprentice">
      <p>{{ $t('application.message.info1') }}</p>

      <i18n path="application.message.info3" tag="p">
        <a :href="links.main.bynContactRegions" target="_blank">{{ $t('application.message.link') }}</a>
      </i18n>
    </template>

    <!-- Form with apprentice application message input field -->
    <v-textarea
      class="mt-8"
      name="input-7-4"
      v-model="message"
      outlined
      placeholder=" "
      label="Meddelande"
      :value="message"
    ></v-textarea>
    <!-- Go to a next  step-->
    <NextButton class="mt-6" :isEnterSubmit="false" @click="nextStep">{{ $t('tour.next') }}</NextButton>

    <!-- 
        Fire 2 if his company application or -1 if want to go to previous step
       @arg The argument is a integer representing (in which step to go)
    -->
    <div v-if="selectedApplication">
      <div v-if="selectedApplication.isCompanyApplication">
        <BottomNav v-if="loGet(selectedApplication, 'company.hasDepartments')" @clicked="$emit('goToStep', '8')" />
        <BottomNav v-else @clicked="$emit('goToStep', '2')" />
      </div>
      <div v-else>
        <BottomNav v-if="selectedApplication.departmentId > 0" @clicked="$emit('goToStep', '-1')" />
        <BottomNav v-else @clicked="$emit('goToStep', '-2')" />
      </div>
    </div>
  </v-container>
</template>

<script>
// Entryform for unknown user to become a apprentice
import {mapActions, mapGetters} from 'vuex'
import pick from 'lodash/pick'
import get from 'lodash/get'
import {RulesMixin} from '@/components/mixins'
import NextButton from '@/components/Common/NextButton'
import BottomNav from '@/components/Application/BottomNav'

// @group Application-Apprentice
// ApplicationMessage component
export default {
  name: 'ApplicationMessage',

  mixins: [RulesMixin],

  components: {
    NextButton,
    BottomNav
  },

  data: () => ({
    links: require('../../../lib/external-links.json'),
    application: null,
    message: '',
    fields: ['id', 'step'],
    valid: true
  }),

  created() {
    this.initApplication()
  },

  watch: {
    /**
     * @vuese
     * Used to watch the selectedApplication and call initApplication
     * @arg called with no argument
     */
    selectedApplication: {
      handler: function () {
        this.initApplication()
      },
      deep: true
    },
    /**
     * @vuese
     * Used to watch the currentStep and call initApplication
     * @arg called with no argument
     */
    currentStep: {
      handler: function () {
        this.initApplication()
      },
      deep: true
    }
  },

  computed: {
    ...mapGetters('application', ['currentStep', 'selectedApplication']),
    ...mapGetters('currentuser', ['currentUser', 'isApprentice'])
  },

  methods: {
    ...mapActions('application', ['setSelectedApplication', 'updateSelectedApplication']),
    /**
     * @vuese
     * Used to Initialize application with either selected message or empty message
     */
    initApplication() {
      //- Initialize application with either selected or empty application

      if (this.selectedApplication && this.selectedApplication.id) {
        this.application = pick(this.selectedApplication, this.fields)
      } else {
        this.application = Object.fromEntries(
          this.fields.map(f => {
            return [f, null]
          })
        )
        //- And add defaults
        if (this.currentUser) {
          this.application.personalNumber = this.currentUser.personalNumber
        }
      }
      //- And add default message if it exist
      const notification = get(this, 'selectedApplication.notification.notification', null)
      if (notification) {
        this.message = notification
      }
      this.application.step = this.currentStep
    },
    /**
     * @vuese
     * Used to go to the next step
     */
    async nextStep() {
      let notification = {
        notification: {
          notification: this.message,
          fromOrganization: this.selectedApplication.companyId
        }
      }
      let application = {...this.application, ...notification}

      if (this.application.id && this.application.id > 0) {
        /**
         * @vuese
         * Used to update application in vuex store
         * @arg The  new param is application message
         */
        this.updateSelectedApplication(application)
        // Fire +1 and go to the next step
        // @arg The argument is a integer representing (in which step to go)
        this.$emit('goToStep', '+1')
      }
    }
  }
}
</script>

<style scoped></style>
